import React from 'react';
import { PropTypes as T } from 'prop-types';
import { FormGroup, Label, Button } from 'reactstrap';

import BoundInput from 'app/components/forms/input/bound_input';
import BoundSelect, { Option } from 'app/components/forms/input/bound_select';
import FormRow from 'app/components/bootstrap/form_row';
import ColFormLabel from 'app/components/bootstrap/col_form_label';

import Base from 'app/components/model_forms/base';
import CustomsItemView from 'app/components/model_forms/customs_item';
import CustomsInfo from 'app/models/customs_info';
import CustomsItem from 'app/models/customs_item';

export const CONTENTS_TYPES = [
  new Option('', 'Choose'),
  new Option('merchandise', 'Merchandise'),
  new Option('returned_goods', 'Returned Goods'),
  new Option('documents', 'Documents'),
  new Option('gift', 'Gift'),
  new Option('sample', 'Sample'),
  new Option('other', 'Other'),
];

export const RESTRICTION_TYPES = [
  new Option('', 'Choose'),
  new Option('none', 'None'),
  new Option('other', 'Other'),
  new Option('quarantine', 'Quarantine'),
  new Option('sanitary_phytosanitary_inspection', 'Sanitary Phytosanitary Inspection'),
];

export const NON_DELIVERY_OPTIONS = [
  new Option('', 'Choose'),
  new Option('return', 'Return'),
  new Option('abandon', 'Abandon'),
];

export default class CustomsInfoForm extends Base {
  static propTypes = {
    model: T.instanceOf(CustomsInfo).isRequired,
  }

  addItem() {
    this.props.model.get('customs_items').add(new CustomsItem());
  }

  removeItem(customsItem) {
    this.props.model.get('customs_items').remove(customsItem);
  }

  render() {
    const customsItems = this.props.model.get('customs_items').models || [];
    const { model } = this.props;

    return (
      <div>
        <FormRow>
          <FormGroup className="col-md-6">
            <ColFormLabel>Contents Type</ColFormLabel>
            <BoundSelect bsSize="sm" model={model} property="contents_type" options={CONTENTS_TYPES} />
          </FormGroup>

          <FormGroup className="col-md-6">
            <ColFormLabel>Contents Explanation <small>(if {'"other"'})</small></ColFormLabel>
            <BoundInput bsSize="sm" property="contents_explanation" model={model} />
          </FormGroup>
        </FormRow>

        <FormRow>
          <FormGroup className="col-md-6">
            <ColFormLabel>Restriction Type</ColFormLabel>
            <BoundSelect bsSize="sm" model={model} property="restriction_type" options={RESTRICTION_TYPES} />
          </FormGroup>

          <FormGroup className="col-md-6">
            <ColFormLabel>Restriction Comments <small>(if {'"other"'})</small></ColFormLabel>
            <BoundInput bsSize="sm" property="restriction_comments" model={model} />
          </FormGroup>
        </FormRow>

        <FormGroup>
          <ColFormLabel>Non-Delivery Action</ColFormLabel>
          <BoundInput bsSize="sm" property="non_delivery_option" model={model} options={NON_DELIVERY_OPTIONS} />
        </FormGroup>

        <FormGroup>
          <ColFormLabel>EEL or PFC</ColFormLabel>
          <BoundInput bsSize="sm" property="eel_pfc" model={model} />
        </FormGroup>

        <hr />

        <h6>Customs Items</h6>

        { customsItems.map(c => (
          <div key={`item-${c.cid}`}>
            <CustomsItemView model={c} />
            <Button onClick={() => { this.removeItem(c); }}>Remove This Item</Button>
            <hr />
          </div>
        )) }

        <Button onClick={() => { this.addItem(); }}>Add Item</Button>

        <hr />

        <FormGroup check>
          <Label check>
            <BoundInput type="checkbox" property="customs_certify" model={model} />
            I certify that the information provided is accurate.
          </Label>
        </FormGroup>

        <FormGroup>
          <ColFormLabel>Signature</ColFormLabel>
          <BoundInput bsSize="sm" property="customs_signer" model={model} />
        </FormGroup>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/model_forms/customs_info/index.jsx